export enum StatusProduct {

	CONTRACT_ANALYSIS_DEPTO = 5,
	FINANCIAL_STATEMENT_DEPTO_ANALYSIS = 10,
	AWAITING_AP_SUP_FINANC = 15,
	CANCELLED = 20,
	ACTIVE = 25,
	INACTIVE = 30

}